import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import type { Action, StoreActionApi } from '@atlassian/react-sweet-state';
import type { ObjectActivityTimelineState } from '../../../../common/types/store.tsx';
import {
	isTimelineEventsServiceResponseData,
	isTimelineEventsServiceResponseError,
} from '../../../../common/types/timeline-event.tsx';
import { fetchChangesAndIncidents } from '../../../../services/changes-and-incidents/index.tsx';

export const PAGE_SIZE = 50;

export type FetchTimelineEventsActionArgs = {
	affectedServicesFieldId?: string;
	requestTypeFieldId?: string;
	serviceId?: string;
};

export const fetchChangesAndIncidentsNextPage =
	({
		affectedServicesFieldId,
		requestTypeFieldId,
		serviceId,
	}: FetchTimelineEventsActionArgs): Action<ObjectActivityTimelineState> =>
	async ({ getState, setState }: StoreActionApi<ObjectActivityTimelineState>) => {
		if (affectedServicesFieldId == null || requestTypeFieldId == null || serviceId == null) {
			return;
		}

		const existingState = getState();

		if (existingState.loading || existingState.page.isLast) {
			return;
		}

		setState({
			...existingState,
			loading: true,
			error: null,
		});

		const start = existingState.page.current * PAGE_SIZE;
		const serviceResponse = await fetchChangesAndIncidents(
			affectedServicesFieldId,
			requestTypeFieldId,
			serviceId,
			start,
			PAGE_SIZE,
		);

		if (isTimelineEventsServiceResponseData(serviceResponse)) {
			setState({
				...existingState,
				timelineEvents: (existingState.timelineEvents ?? []).concat(serviceResponse.data),
				loading: false,
				error: null,
				page: {
					current: existingState.page.current + 1,
					isLast: serviceResponse.data.length < PAGE_SIZE,
				},
			});
		} else if (isTimelineEventsServiceResponseError(serviceResponse)) {
			setState({
				...existingState,
				loading: false,
				error: serviceResponse.error,
			});

			fireCmdbErrorAnalytics({
				meta: {
					id: 'fetchTimelineEventsNextPage',
					packageName: 'jiraServicedeskInsightObjectActivityTimelineStore',
				},
				attributes: {
					errorType: serviceResponse.error,
				},
			});
		}
	};
